export type MetricKeys = keyof typeof events;
export type MetricsEvent = typeof events[MetricKeys];

export const events = {
  clickFilterTab: 'click_tab',
  clickFilter: 'click_filter',
  searchLoads: 'SearchLoads',
  savedFiltersOpen: 'SavedFiltersOpen',
  favoritesOpen: 'FavouritesOpen',
  historyOpen: 'SearchHistoryOpen',
  byTrucksOpen: 'TruckSearchOpen',
} as const;
